// Module
var code = "<h1>Hello!</h1>";
// Exports
module.exports = code;